/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
import { useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material'
import { InfoOutlined } from '@mui/icons-material'

import { get } from 'services/api'
import ResumeTable from 'components/ResumeTable'
import ExpandedInfo from 'components/ExpandedInfo'
import { Modal, Pagination } from 'components'
import SearchBar from 'components/SearchBar'
import styles from './styles'

const Home = () => {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)

  const [modal, setModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [applications, setApplications] = useState(null)
  const [clickedPerson, setClickedPerson] = useState(null)
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [pagesNumber, setPagesNumber] = useState(1)
  const [searchParams, setSearchParams] = useState({
    hide_empty_applications: true,
  })

  useEffect(() => {
    getData()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size, searchParams])

  const getData = async () => {
    setLoading(true)

    const res = await get({
      url: `/applications`,
      token,
      params: { ...searchParams, page: page + 1, size: size },
    })

    setApplications(res?.items)
    setPagesNumber(res?.total)
    setLoading(false)
  }

  const handleOpenModal = (info) => {
    setClickedPerson(info)
    setModal(true)
  }

  const handleCloseModal = () => {
    setClickedPerson(null)
    setModal(false)
  }

  const handlePageChange = (event, page) => {
    setPage(page)
  }

  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value)
    setPage(0)
  }

  const handleChangeSearchTerm = (value) => {
    if (JSON.stringify(searchParams) !== JSON.stringify(value)) {
      setPage(0)
      setSearchParams(value)
    }
  }

  const reloadData = () => {
    getData()
  }

  return (
    <div className={classes.root}>
      <div className={classes.topBar}>        
        <SearchBar searchParams={searchParams} setSearchParams={handleChangeSearchTerm} />
      </div>

      {loading ? (
        <div className={classes.loading}>
          <CircularProgress size={64} color="primary" />
          <span className={classes.loadingText}>Buscando aplicações...</span>
        </div>
      ) : (
        <React.Fragment>
          {false && (
            <div className={classes.containers}>
              <div className={classes.dataContainer}>
                Estatísticas desse mês
              </div>

              <div className={classes.dataContainer}>
                Estatísticas de todos os tempos
              </div>
            </div>
          )}

          <div className={classes.tableContainer}>
            {applications ? (
              <ResumeTable
                data={applications}
                handleOpenModal={handleOpenModal}
                reloadData={reloadData}
              />
            ) : (
              <div className={classes.noData}>
                <span>
                  <InfoOutlined fontSize="inherit" />
                </span>
                <span>Nenhum registro encontrado</span>
              </div>
            )}
          </div>

          <Pagination
            count={pagesNumber}
            component="div"
            page={page}
            rowsPerPage={size}
            rowsPerPageOptions={[10, 15, 20, 25, 30]}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          {clickedPerson && (
            <Modal
              open={modal}
              onClose={handleCloseModal}
              title="Informações detalhadas da aplicação"
            >
              <ExpandedInfo
                handleClose={handleCloseModal}
                application_id={clickedPerson.uuid}
              />
            </Modal>
          )}
        </React.Fragment>
      )}
    </div>
  )
}

export default Home
